import React from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers";

import { DateFieldProps } from "./DateField.types";
import TextField from "../TextField";
import { TextFieldProps } from "@mui/material";
import Calendar from "@tiny/icons/generated/Calendar";
import { usePopoverStyles } from "./DateField.styles";
import { addMinutes } from "date-fns";

function DateField(props: DateFieldProps) {
  const {
    value: valueProp,
    onChangeValue,
    onBlur: onBlurProp,
    format = "MM/dd/yyyy",
    helperText,
    error,
    ...other
  } = props;

  const popoverClasses = usePopoverStyles();

  const handleChange = React.useCallback(
    (date: Date | null) => {
      const utcDate =
        date && !isNaN(date.getTime())
          ? addMinutes(date, date.getTimezoneOffset() * -1).getTime()
          : null;
      onChangeValue?.(utcDate);
    },
    [onChangeValue]
  );

  const value = React.useMemo(() => {
    if (!valueProp) {
      return null;
    }
    const date = new Date(valueProp);
    return addMinutes(date, date.getTimezoneOffset());
  }, [valueProp]);

  return (
    <DesktopDatePicker
      {...other}
      inputFormat={format}
      onChange={handleChange}
      value={value}
      renderInput={(params) => (
        <TextFieldComponent
          {...params}
          onBlur={onBlurProp}
          error={Boolean(error) || params.error}
          helperText={helperText || params.helperText}
        />
      )}
      PaperProps={{
        classes: popoverClasses,
      }}
    />
  );
}

function TextFieldComponent(props: TextFieldProps) {
  const { InputProps, disabled } = props;

  const handleCalendarClick = React.useCallback(() => {
    const adorment = InputProps?.endAdornment as React.ReactElement;
    const child = React.Children.only(adorment.props.children);
    child.props.onClick();
  }, [InputProps?.endAdornment]);

  const endIcon = (
    <button type="button" onClick={handleCalendarClick} disabled={disabled}>
      <Calendar />
    </button>
  );

  return <TextField {...props} endIcon={endIcon} />;
}

export default DateField;
